// extracted by mini-css-extract-plugin
module.exports = {"about_container":"aboutDiv_about_container__2bwnt","mediaBox":"aboutDiv_mediaBox__2yAM5","left":"aboutDiv_left__1gi0x","right":"aboutDiv_right__3ywXm"};